import Cookies from "js-cookie";
import { MealPlanEntry } from "../models/MealPlanEntry";

export function getMealPlanForWeek(weekStart: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/mealplan?weekStart=' + weekStart;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function saveMealPlanEntry(entry: MealPlanEntry) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/mealplan';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(entry)
    }).then(response => {
        return response.ok ? response.json() : Promise.reject();
    });
}

export function deleteMealPlanEntry(mealPlanEntryId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/mealplan/' + mealPlanEntryId;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? true : Promise.reject();
    });
}
